import { Component, OnInit, OnDestroy, AfterViewInit, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import { GridDataResult, GridComponent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, SortDescriptor, orderBy } from '@progress/kendo-data-query';

//import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

import {environment} from '../../environments/environment';
@Component({
  selector: 'app-actual-cost-hour-data',
  templateUrl: './actual-cost-hour-data.component.html',
  styleUrls: ['./actual-cost-hour-data.component.css']
})
export class ActualCostHourDataComponent implements OnInit, OnDestroy {
  private loaded = false;
  public gridData: any[] = [];
  public gridView: GridDataResult;
  public state: State = {
    skip: 0,
    take: 50
  };

  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;
  initialLoad = false;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }


  ngAfterViewInit() {
    this.reload();
    this.initialLoad = true;
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.ActualCostHourData.columns;
    this.data = this.report.ActualCostHourData.data;
    this.gridData = this.report.ActualCostHourData.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
    this.gridView = process(this.gridData, this.state);
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.gridData = this.report.ActualCostHourData.data;
    this.gridView = process(this.gridData, this.state);
  }

}


// WEBPACK FOOTER //
// ./src/app/actual-cost-hour-data/actual-cost-hour-data.component.ts